export default __webpack_public_path__ + "static/media/busch-flex.b47a6c1b.webp";